import {ReactNode} from "react";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";
import {BillingPeriod} from "@/lib/types/billing.ts";
import {BillingPeriodPicker} from "@/pages/billing/components/BillingPeriodPicker.tsx";
import {UpsellAlert} from "@/pages/billing/components/UpsellAlert.tsx";
import {CtaComparisonButtonGroup} from "@/pages/billing/subscription/components/CtaComparisonButtonGroup.tsx";

export interface CtaBlurbComparisonButtonGroupProps {
  billingPeriod: BillingPeriod;
  onChange: (billingPeriod: BillingPeriod) => void;
  text_success: string;
  title_cont: string;
  copy: ReactNode;
  tooltip?: string;
}

export const CtaBlurbComparisonButtonGroup = ({
  billingPeriod,
  onChange,
  text_success,
  title_cont,
  copy,
  tooltip,
}: CtaBlurbComparisonButtonGroupProps) => {
  const {user} = useCurrentUserContext();
  return (
    <div>
      <UpsellAlert title={text_success} title_cont={title_cont}>
        {copy}
      </UpsellAlert>
      <div className="d-flex flex-row justify-content-between align-items-center">
        <TooltipWrapper toolTip={tooltip}>
          <div>
            <BillingPeriodPicker
              value={billingPeriod}
              onChange={onChange}
              disabled={!user?.account.free_trial_expires_at}
            />
          </div>
        </TooltipWrapper>
        <CtaComparisonButtonGroup />
      </div>
    </div>
  );
};
